var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cm-nav-chapter-dropdown",
    class: _vm.currentChapter && ("ch_" + (_vm.currentChapter.id)),
    on: {
      "focusout": _vm.handleFocusOut
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cm-nav-chapter-dropdown__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textInput),
      expression: "textInput"
    }],
    ref: "input",
    staticClass: "cm-nav-chapter-dropdown__input is-boxed",
    attrs: {
      "type": "text",
      "placeholder": _vm.currentChapter ? _vm.currentChapter.name : 'Find your city',
      "autocomplete": "off",
      "role": "combobox",
      "aria-haspopup": "listbox",
      "aria-autocomplete": "list",
      "aria-controls": (_vm.uid + "-results"),
      "aria-label": "Find your city",
      "spellcheck": "false",
      "aria-expanded": _vm.isListVisible,
      "autocapitalize": "off",
      "aria-activedescendant": _vm.selectedChapter ? _vm.selectedChapter.uid : null
    },
    domProps: {
      "value": (_vm.textInput)
    },
    on: {
      "focus": function($event) {
        _vm.isListVisible = true
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        (function (e) { return _vm.onArrow(e, -1); })($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        (function (e) { return _vm.onArrow(e, 1); })($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onEnter($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.onEscape($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "main-menu nav__mobile-menu mobile",
    attrs: {
      "id": "menu--chapters"
    }
  }, _vm._l((_vm.filteredChapters), function(chapter) {
    return _c('li', {
      key: ("mobile-" + (chapter.uid)),
      staticClass: "cm-nav-chapter-dropdown__city",
      class: ("ch_" + (chapter.id)),
      attrs: {
        "role": "option"
      }
    }, [_c('a', {
      attrs: {
        "href": chapter.link,
        "id": chapter.uid
      }
    }, [_c('span', {
      staticClass: "cm-nav-chapter-dropdown__title"
    }, [_vm._v(_vm._s(chapter.name))])])])
  })), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isListVisible),
      expression: "isListVisible"
    }],
    staticClass: "cm-nav-chapter-dropdown__list desktop",
    attrs: {
      "id": (_vm.uid + "-results"),
      "role": "listbox"
    }
  }, _vm._l((_vm.filteredChapters), function(chapter) {
    return _c('li', {
      key: ("desktop-" + (chapter.uid)),
      staticClass: "cm-nav-chapter-dropdown__city",
      class: ("ch_" + (chapter.id)),
      attrs: {
        "aria-selected": chapter.abbreviation === _vm.selectedChapterAbbr,
        "role": "option"
      }
    }, [_c('a', {
      attrs: {
        "href": chapter.link,
        "tabindex": "-1",
        "id": chapter.uid
      }
    }, [_c('span', {
      staticClass: "cm-nav-chapter-dropdown__title"
    }, [_vm._v(_vm._s(chapter.name))])])])
  }))])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "cm-nav-chapter-dropdown__toggle nav__toggle",
    attrs: {
      "aria-controls": "menu--chapters",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "nav__icon ss-icon"
  }, [_vm._v("navigate")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142899d4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-nav-chapter-dropdown.vue
// module id = null
// module chunks = 